<template>
  <div>
    <div class="notification__wrapper">
      <div class="notification__content">
        <span v-html="notificationText" class="notification-text"></span>
        <span v-if="linkUrl" class="contains-action-link">
          <RouterLink :to="linkUrl">
            <span v-html="$filters.iconifyGreaterThanSign(linkText)"></span>
          </RouterLink>
        </span>
        <span v-else @click.stop="openContactForm()" class="contains-action-link">
          <a class="link-text inline" role="button" v-html="$filters.iconifyGreaterThanSign(linkText)"></a>
        </span>
      </div>
      <dialogue identifier="notification">
        <template #dialogueContent>
          <div v-html="modalContent"></div>
        </template>
      </dialogue>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'notification',
  props: {
    notificationText: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
    linkUrl: {
      type: String,
      required: false,
    },
    modalContent: {
      type: String,
      required: false,
    },
  },
  methods: {
    openContactForm() {
      this.$bus.$emit('openDialogue', 'notification');
    },
  },
  components: {
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
  },
};
</script>
